import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { connect } from 'react-redux';
import fetch from 'services/fetch';

// Components
import TextBlock from 'components/textBlock';

// Styles
import styles from './landingPage.scss';

class LandingPage extends Component {
  componentDidMount() {
    const {
      match: { params: { category } },
      fetchLandingMeta,
      fetchIndicatorMeta,
    } = this.props;

    if ('undefined' !== typeof fetchLandingMeta[category]) {
      fetchLandingMeta[category]();
      fetchIndicatorMeta(category);
    }
  }

  render() {
    const {
      intro,
      featuredIndicators,
      isFetching,
    } = this.props;
    if (isFetching) {
      return false;
    }

    // Remove empty featured indicators
    const indicatorsToDisplay = featuredIndicators.filter(({ id }) => (0 < id));

    return (
      <div className={styles.landingPage}>
        <div className={styles.wrapper}>
          <div className={styles.section}>
            <ReactMarkdown source={intro} className={styles.markdown} />
          </div>
          {0 < featuredIndicators.length &&
            <div className={styles.section}>
              <h2 className={styles.heading}>
                Featured Indicators
              </h2>
              <ul className={styles.featuredIndicators}>
                {indicatorsToDisplay.map(({ title, excerpt, link }) => (
                  <li
                    key={title}
                    className={styles.featuredIndicator}
                  >
                    <a
                      href={link}
                      className={styles.link}
                    >
                      <TextBlock
                        title={title}
                        text={excerpt}
                        classNames={{
                          titleClassName: styles.indicatorTitle,
                        }}
                      />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          }
        </div>
      </div>
    );
  }
}

LandingPage.defaultProps = {
  intro: '',
  featuredIndicators: [],
};

LandingPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      category: PropTypes.string,
    }),
  }).isRequired,
  intro: PropTypes.string,
  featuredIndicators: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    excerpt: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  })),
  fetchLandingMeta: PropTypes.shape({
    usdata: PropTypes.func,
    international: PropTypes.func,
  }).isRequired,
  fetchIndicatorMeta: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { data: { landingMeta, isFetching } } = state;
  const { match: { params: { category } } } = ownProps;

  if ('undefined' !== typeof landingMeta[category]) {
    return {
      intro: landingMeta[category].long_description,
      featuredIndicators: landingMeta[category].curated_data_center_items,
      isFetching:
        -1 < isFetching.indexOf('landingMetaUS') ||
        -1 < isFetching.indexOf('landingMetaInternational'),
    };
  }
  return { isFetching: true };
};

const mapDispatchToProps = (dispatch) => ({
  fetchLandingMeta: {
    usdata: () =>
      dispatch(fetch.landingMeta.fetchLandingMetaUS()),
    international: () =>
      dispatch(fetch.landingMeta.fetchLandingMetaInternational()),
  },
  fetchIndicatorMeta: (category) => dispatch(fetch.indicatorMeta(category)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LandingPage);



// WEBPACK FOOTER //
// ./app/components/landingPage/index.js